import styled from 'styled-components';

export const Label = styled.label`
  user-select: none;
`;
